import * as React from "react";
import { Table } from "../../newcomponents/table/table";

interface DetectedTagsProps {
  value: any;
  detectionMap: Record<string, string>;
  detectValue: (value: any, key: string) => boolean;
}

interface Props extends DetectedTagsProps {
  className?: string;
  style?: React.CSSProperties;
  pluralLabel: string;
}
export const DetectedTags: React.FC<Props> = ({ pluralLabel, value, detectionMap, detectValue }) => {
  const detections: { key: string; value: string }[] = React.useMemo(() => {
    const _detections: { key: string; value: string }[] = [];
    for (const key of Object.keys(detectionMap)) {
      const detected = detectValue(value, key);
      if (detected) {
        _detections.push({ key, value: detectionMap[key] });
      }
    }
    return _detections;
  }, [detectionMap, value]);

  if (detections.length < 1) {
    return null;
  }

  return (
    <div className="mb-10">
      <Table
        tableId="detected-tags"
        title={() => <div>Detected {pluralLabel}</div>}
        styles={{ header: { marginBottom: 0 } }}
        hideSettings
        data={detections}
        columns={[
          { id: "key", label: "Key" },
          { id: "value", label: "Value" },
        ]}
      />
    </div>
  );
};

export function useHasDetectedTags({ value, detectValue, detectionMap }: DetectedTagsProps): boolean {
  const detections: Record<string, string> = React.useMemo(() => {
    const _detections: Record<string, string> = {};
    for (const key of Object.keys(detectionMap)) {
      const detected = detectValue(value, key);
      if (detected) {
        _detections[key] = detectionMap[key];
      }
    }
    return _detections;
  }, [detectionMap, value]);

  return Object.keys(detections).length > 0;
}
